import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const AppFooter = () => {
  return (
    <Footer style={{ textAlign: 'center', background: '#f0f2f5' }}>
      <div>情绪记录应用 ©{new Date().getFullYear()} - 关爱心理健康</div>
      <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
        Powered by Spring Boot & React
      </div>
    </Footer>
  );
};

export default AppFooter; 